export default function videoAutoplay() {
	document.querySelectorAll( 'video[autoplay]' ).forEach( function( video ) {
		video.muted = true;
		video.setAttribute( 'muted', '' );
		video.setAttribute( 'playsinline', '' );

		// Override pause to prevent mejs from pausing during setup.
		var originalPause = video.pause.bind( video );
		var allowPause = false;

		video.pause = function() {
			if ( allowPause ) {
				originalPause();
			}
		};

		// Restore normal pause after mejs is done setting up.
		setTimeout( function() {
			allowPause = true;
		}, 4000 );

		function tryPlay() {
			video.play().catch( function() {} );
		}

		// Mark the wrapper as loaded once the video is playing.
		function markLoaded() {
			var wrapper = video.closest( '.content__video' );
			if ( wrapper ) {
				wrapper.classList.add( 'is-loaded' );
			}
		}

		video.addEventListener( 'playing', markLoaded, { once: true } );

		if ( video.readyState >= 3 ) {
			tryPlay();
		} else {
			video.addEventListener( 'canplay', tryPlay, { once: true } );
		}
	} );
}
